import { z } from 'zod';
import { ProjectType, ProjectStatus } from '../enums';

export { ProjectType, ProjectStatus };

export const ProjectTypeSchema = z.nativeEnum(ProjectType);
export const ProjectStatusSchema = z.nativeEnum(ProjectStatus);

export const ProjectSchema = z.object({
  id: z.string().uuid(),
  client_id: z.string().uuid(),
  specifier_id: z.string().uuid().nullable(),
  project_name: z.string().min(1),
  address: z.string().nullable(),
  project_type: ProjectTypeSchema,
  status: ProjectStatusSchema,
  total_gfa: z.number().nullable(),
  general_notes: z.string().nullable(),
  reference_code: z.string().nullable().optional(),
  mxn_exchange_rate: z.number().nullable(),
  mxn_bank_spread: z.number().default(0),
  mxn_rate_fetched_at: z.string().datetime().nullable(),
  created_by: z.string().uuid(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateProjectSchema = z.object({
  client_id: z.string().uuid({ message: 'Client is required' }),
  specifier_id: z.string().uuid().optional(),
  project_name: z.string().min(1, 'Project name is required'),
  address: z.string().optional(),
  project_type: ProjectTypeSchema.default(ProjectType.RESIDENTIAL),
});

export const UpdateProjectSchema = z.object({
  client_id: z.string().uuid().optional(),
  specifier_id: z.string().uuid().nullable().optional(),
  project_name: z.string().min(1).optional(),
  address: z.string().nullable().optional(),
  project_type: ProjectTypeSchema.optional(),
  status: ProjectStatusSchema.optional(),
  total_gfa: z.number().nullable().optional(),
  general_notes: z.string().nullable().optional(),
  reference_code: z.string().nullable().optional(),
  excluded_labor_categories: z.string().nullable().optional(),
  mxn_exchange_rate: z.number().nullable().optional(),
  mxn_bank_spread: z.number().nullable().optional(),
  mxn_rate_fetched_at: z.string().datetime().nullable().optional(),
  nesting_cost_overrides: z.string().nullable().optional(),
});

export const ProjectQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
  status: ProjectStatusSchema.optional(),
  type: ProjectTypeSchema.optional(),
  search: z.string().optional(),
  client_id: z.string().uuid().optional(),
});

export type Project = z.infer<typeof ProjectSchema>;
export type CreateProject = z.infer<typeof CreateProjectSchema>;
export type UpdateProject = z.infer<typeof UpdateProjectSchema>;
export type ProjectQuery = z.infer<typeof ProjectQuerySchema>;
export type ProjectTypeEnum = z.infer<typeof ProjectTypeSchema>;
export type ProjectStatusEnum = z.infer<typeof ProjectStatusSchema>;
